import React from "react";

export default function role() {
  return (
    <summary className="statement">
      <span className="animation-wrapper">
        <h2 className="text-typping-anination">I'm Sathish Selvam,</h2>
      </span>
      <h1 className="aninate-hideshow">Software engineer and BI dashboard developer</h1>
      <p>
        I specialize in rapidly building software company and web applications. <br /> I talk about my journey on Twitter, commit code to Github, and build network on LinkedIn.
      </p>
    </summary>
  );
}
